import { StudyPhase } from '@longtail-education/superprepstudy-data-model-frontend'

/**
 * Re-exports the StudyPhase enum from the data model.
 */
export { StudyPhase }

/**
 * Checks if the given study phase is a regular study phase (Review or Acquisition).
 * @param phase The study phase to check.
 * @returns True if the study phase is Review or Acquisition, otherwise false.
 */
export const isRegularStudyPhase = (phase?: StudyPhase) =>
  [StudyPhase.Review, StudyPhase.Acquisition].includes(phase ?? StudyPhase.Practice)

export const isQuizStudyPhase = (phase?: StudyPhase) =>
  [StudyPhase.Quiz].includes(phase ?? StudyPhase.Practice)

/**
 * Converts a string to a StudyPhase enum value.
 * @param s The string to convert.
 * @returns The corresponding StudyPhase enum value.
 */
export const studyPhaseFromString = (s: string) => {
  switch (s.toLowerCase()) {
    case StudyPhase.Acquisition:
      return StudyPhase.Acquisition
    case StudyPhase.Review:
      return StudyPhase.Review
    case StudyPhase.Practice:
    default:
      return StudyPhase.Practice
  }
}

/**
 * Converts a StudyPhase enum value to a string.
 * @param s The StudyPhase enum value to convert.
 * @param finalcase The desired case for the result string ('lowercase', 'uppercase', or 'titlecase').
 * @returns The string representation of the StudyPhase enum value.
 */
export const studyPhaseToString = (
  s: StudyPhase,
  finalcase: 'lowercase' | 'uppercase' | 'titlecase' = 'titlecase'
) => {
  const result = ((s) => {
    switch (s.toLowerCase()) {
      case StudyPhase.Acquisition:
        return 'Acquisition'
      case StudyPhase.Review:
        return 'Review'
      case StudyPhase.Practice:
      default:
        return 'Practice'
    }
  })(s)
  return finalcase === 'lowercase'
    ? result.toLowerCase()
    : finalcase === 'uppercase'
    ? result.toUpperCase()
    : result
}
